import { render, staticRenderFns } from "./EconomicGroupTab.vue?vue&type=template&id=681eec30"
import script from "./EconomicGroupTab.vue?vue&type=script&lang=js"
export * from "./EconomicGroupTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports